import {
  // ##### 24-05-24 Komarov
  GET_HOTEL_CONTENT,
  // ##### 25-02-15 Komarov
  GET_HOTEL_RATES_ERR2,
  GET_HOTEL_RATES_REQ2,
  GET_HOTEL_RATES_RES2,
  // ##### 25-05-09 Komarov
  GET_HOTEL_RATES_ERR4,
  GET_HOTEL_RATES_REQ4,
  GET_HOTEL_RATES_RES4,
  // ##### 24-06-10 Komarov
  RESET_HOTEL_RATES,
} from '../constants';

const initState = {
  // ##### 24-05-24 Komarov
  hotelContent: [],
  hotelrates: [],
  hotelrates_loaded: false,
  hotelrates_errors: [],
  // ##### 25-02-15 Komarov
  hotelrates2: [],
  hotelrates_loaded2: false,
  hotelrates_errors2: [],
  // ##### 25-05-09 Komarov
  hotelrates4: [],
  hotelrates_loaded4: false,
  hotelrates_errors4: [],
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    //   ##### 25-02-15 Komarov
    case GET_HOTEL_RATES_REQ2:
      return {
        ...state,
        hotelrates_loaded2: false,
      };

    case GET_HOTEL_RATES_RES2:
      return {
        ...state,
        hotelrates_loaded2: true,
        hotelrates2: action.payload,
      };

    //   ##### 25-02-15 Komarov
    case GET_HOTEL_RATES_ERR2:
      return {
        ...state,
        hotelrates_errors2: [...state.hotelrates_errors2, action.error],
      };

    //   ##### 25-05-09 Komarov
    case GET_HOTEL_RATES_REQ4:
      return {
        ...state,
        hotelrates_loaded4: false,
      };

    case GET_HOTEL_RATES_RES4:
      return {
        ...state,
        hotelrates_loaded4: true,
        hotelrates4: action.payload,
      };

    //   ##### 25-02-15 Komarov
    case GET_HOTEL_RATES_ERR4:
      return {
        ...state,
        hotelrates_errors4: [...state.hotelrates_errors4, action.error],
      };

    // ##### 24-06-10 Komarov
    case RESET_HOTEL_RATES:
      return {
        ...state,
        hotelrates_loaded: false,
        hotelrates: initState.hotelrates,
      };

    // ##### 24-05-24 Komarov
    case GET_HOTEL_CONTENT:
      return {
        ...state,
        hotelContent: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
